import { Suspense, lazy, useMemo } from 'react';
import { RouteObject } from 'react-router';

import { FeatureToggle, routes } from '@fly/shared';
import { useFeatureToggle } from '@fly/shared-hooks';
import { FlyLoader } from '@fly/shared-ui';

import { Download } from './Download';

const Home = lazy(() => import('./Home'));

const downloadRoute: RouteObject = {
  path: routes.DOWNLOAD.ROOT,
  element: <Download />,
};

const homeRoute: RouteObject = {
  path: routes.HOME.ROOT,
  element: (
    <Suspense fallback={<FlyLoader />}>
      <Home />
    </Suspense>
  ),
};

/** Registers /home only while feature_landing is off (external Astro site when on). */
export function useDownloadRoutes(): RouteObject[] {
  const { hasFeature } = useFeatureToggle();
  const showHome = !hasFeature(FeatureToggle.LANDING);

  return useMemo(
    () => (showHome ? [downloadRoute, homeRoute] : [downloadRoute]),
    [showHome]
  );
}
